module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/icon_arrow_down-b40dcb947991a2c5b0f9473902d89139.svg";